import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06126b4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "competitionlist" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 mb-4 centertext" }, "Stævner", -1))
const _hoisted_3 = { class: "layout gutter--md" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "center mb-2" }, "Sprog / Language", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Dansk")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("English")
const _hoisted_8 = { class: "searchcontrols row align--center justify--space-between mb-4" }
const _hoisted_9 = { class: "md2 flex xs2 sm2" }
const _hoisted_10 = {
  class: "md5 xs10 flex sm6",
  style: {"display":"flex"}
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_12 = { class: "md3 flex xs12 sm3" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "va-table-responsive row"
}
const _hoisted_15 = { class: "flex md12 va-table va-table--clickable va-table--hoverable" }
const _hoisted_16 = {
  key: 6,
  class: "mobile"
}
const _hoisted_17 = {
  key: 7,
  class: "mobile"
}
const _hoisted_18 = {
  key: 8,
  class: "textcenter"
}
const _hoisted_19 = {
  key: 9,
  class: "textcenter"
}
const _hoisted_20 = {
  key: 0,
  class: "mobile"
}
const _hoisted_21 = {
  key: 1,
  class: "mobile"
}
const _hoisted_22 = { class: "mobile" }
const _hoisted_23 = {
  key: 2,
  class: "centertext"
}
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_27 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_28 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_30 = { class: "selectPageSize" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_divider = _resolveComponent("va-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_va_button_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_va_button, {
              size: "small",
              color: (_ctx.languageValue === 1 ? '#ab0033' : 'primary'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.languageValue = 1))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["color"]),
            _createVNode(_component_va_button, {
              size: "small",
              color: (_ctx.languageValue === 2 ? '#ab0033' : 'primary'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.languageValue = 2))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["color"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_va_button, {
            class: "btn",
            color: "#b4003a",
            rounded: false,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.columnSort('reset')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_va_icon, {
                class: "reset",
                name: "autorenew"
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_va_input, {
            modelValue: _ctx.competitionSearchInputValue,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.competitionSearchInputValue) = $event)),
            label: "Søg",
            onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.findCompetition()), ["enter"])),
            style: {"width":"85%"}
          }, {
            prependInner: _withCtx(() => [
              _createVNode(_component_va_icon, { name: "search" })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_va_button, {
            class: "btn ml-2",
            color: "#b4003a",
            rounded: false,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.findCompetition()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_va_icon, { name: "search" }),
              _hoisted_11
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_va_select, {
            label: "Stævne status",
            modelValue: _ctx.filterByTimeValue,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filterByTimeValue) = $event)),
            options: _ctx.filterByTimeOptions,
            bordered: ""
          }, null, 8, ["modelValue", "options"])
        ])
      ])
    ]),
    _createVNode(_component_va_divider),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.error), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("table", _hoisted_15, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_ctx.languageValue === 1)
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 0,
                      class: "sorting",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.columnSort('staevnenavn')))
                    }, "Stævnenavn"))
                  : (_openBlock(), _createElementBlock("th", {
                      key: 1,
                      class: "sorting",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.columnSort('staevnenavn')))
                    }, "Event")),
                (_ctx.languageValue === 1)
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 2,
                      class: "sorting",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.columnSort('dato')))
                    }, "Afholdes"))
                  : (_openBlock(), _createElementBlock("th", {
                      key: 3,
                      class: "sorting",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.columnSort('dato')))
                    }, "Date")),
                (_ctx.languageValue === 1)
                  ? (_openBlock(), _createElementBlock("th", {
                      key: 4,
                      class: "sorting mobile",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.columnSort('sidstefrist')))
                    }, "Sidste tilmelding"))
                  : (_openBlock(), _createElementBlock("th", {
                      key: 5,
                      class: "sorting mobile",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.columnSort('sidstefrist')))
                    }, "Registration")),
                (_ctx.languageValue === 1)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_16, "Spillested"))
                  : (_openBlock(), _createElementBlock("th", _hoisted_17, "Location")),
                (_ctx.languageValue === 1)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_18, "Yderligere information"))
                  : (_openBlock(), _createElementBlock("th", _hoisted_19, "More information"))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staevners, (staevne, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(staevne.staevne_navn), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.toDanishDateWithWeekDay(staevne.staevne_start, true)), 1),
                  ((_ctx.generateDateString(staevne.staevne_sidstetilmelding) >= _ctx.generateDateString(_ctx.toDaysDate)))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(_ctx.toDanishDateWithWeekDay(staevne.staevne_sidstetilmelding)), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(_ctx.languageValue === 1 ? 'Tilmelding slut' : 'Registration ended'), 1)),
                  _createElementVNode("td", _hoisted_22, _toDisplayString((_ctx.convertHTMLToText(staevne.staevne_spillested))), 1),
                  (staevne.staevne_status)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_23, [
                        ((new Date(staevne.staevne_start).toISOString() < _ctx.toDaysDate))
                          ? (_openBlock(), _createBlock(_component_va_button, {
                              key: 0,
                              size: "small",
                              color: "#b4003a",
                              onClick: ($event: any) => (_ctx.toCompetitionInfo(staevne.id, staevne.staevne_navn, staevne.staevne_start))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Se resultater' : 'See results'), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : (_openBlock(), _createBlock(_component_va_button, {
                              key: 1,
                              size: "small",
                              color: "#b4003a",
                              onClick: ($event: any) => (_ctx.toCompetitionInfo(staevne.id, staevne.staevne_navn, staevne.staevne_start))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Se information' : 'See information'), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_24))
                ]))
              }), 128))
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(_component_va_button, {
        icon: "first_page",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.jumpToPage(1)))
      }),
      _createVNode(_component_va_button, {
        icon: "keyboard_double_arrow_left",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.turnToNewPage(-5)))
      }),
      _createVNode(_component_va_button, {
        icon: "chevron_left",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.turnToNewPage(-1)))
      }),
      _hoisted_26,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.currentPage) = $event)),
        onKeyup: _cache[17] || (_cache[17] = _withKeys(($event: any) => (_ctx.jumpToPage(this.currentPage)), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.currentPage]
      ]),
      (_ctx.totalNumberOfPages === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_27, " af " + _toDisplayString(_ctx.totalNumberOfPages+1), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_28, " af " + _toDisplayString(_ctx.totalNumberOfPages), 1)),
      _createVNode(_component_va_button, {
        icon: "chevron_right",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.turnToNewPage(1)))
      }),
      _createVNode(_component_va_button, {
        icon: "keyboard_double_arrow_right",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.turnToNewPage(5)))
      }),
      _createVNode(_component_va_button, {
        icon: "last_page",
        class: "mr-2",
        size: "small",
        rounded: false,
        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.jumpToPage(this.totalNumberOfPages)))
      }),
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_va_select, {
          class: "mr-2",
          modelValue: _ctx.pageSizeValueString,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.pageSizeValueString) = $event)),
          options: _ctx.pageSizeOptions,
          bordered: ""
        }, null, 8, ["modelValue", "options"])
      ])
    ])
  ]))
}